<template>
  <div class="operate-btn">
    <template v-for="(item, index) in operationData">
      <el-button
        v-show="handleShow(item.dealCount)"
        :key="index"
        type="primary"
        plain
        :class="item.operation"
        @click="clickBtn(item.operation)"
      >
        {{ item.name }}
      </el-button>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import APIS from '@apis/common.js'
export default {
  name: 'OperationBtns',
  props: {
    groupCode: {
      type: String,
      default: ''
    },
    selectLength: {
      type: Number,
      default: 0
    },
    initOperate: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['MenusOper']),
    menuId() {
      if (this.MenusOper.length === 0) return 0
      let menuId = this.MenusOper.find((item) => item.url === this.$route.path)
      return (menuId && menuId.id) || 0
    }
  },
  watch: {
    MenusOper(newVal) {
      if (newVal.length !== 0) {
        let menuId = newVal.find((item) => item.url === this.$route.path)
        this.initBtnData(menuId)
      }
    }
  },
  data() {
    return {
      operationData: [],
      operationArr: ['add', 'edit', 'delete', 'enable', 'disable']
    }
  },
  created() {
    if (this.menuId !== 0 && this.initOperate) {
      this.initBtnData(this.menuId)
    }
  },
  methods: {
    async initBtnData() {
      let params = {
        menuId: this.menuId,
        groupCode: this.groupCode
      }
      let { status, data } = await APIS.sourceMenuOperations({ data: params })
      if (status === 0 && data && data.length !== 0) {
        this.operationData = data.map((item) => {
          let simpleOper = this.operationArr.filter(i => item.code.indexOf(i) !== -1)
          return {
            name: item.name,
            code: item.code, // 简码
            operation: (simpleOper.length !== 0 && simpleOper[0]) || item.code,
            enabled: item.enabled, // 是否启用 0-false,1-true
            dealCount: item.dealCount, // 处理文档个数
            needRefresh: item.needRefresh // 刷新
          }
        })
      } else {
        this.operationData = []
      }
    },
    handleShow(count) {
      if (count === 0) return true
      else if (count === 1) return this.selectLength === 1
      else return this.selectLength >= 1
    },
    clickBtn(code) {
      this.$emit('clickBtn', code)
    }
  }
}
</script>
<style lang='scss' scoped>
// 操作按钮
.operate-btn {
  width: calc(100% - 75px);
  float: left;
  margin-bottom: 15px;
  button {
    min-width: 85px;
    height: 25px;
    padding: 0 10px;
    background: #ffffff;
    border-radius: 3px;
    margin-right: 10px;
    margin-left: 0;
    font-size: 12px;
  }
  .blue-btn {
    border: 1px solid #c3d4f6;
  }
  .grey-btn {
    border: 1px solid #ededed;
    background: #ffffff;
    color: #ccc;
    &:hover {
      border: 1px solid #ededed;
      background: #ffffff;
      color: #ccc;
    }
  }
  :last-child {
    margin-right: 0;
  }
}
</style>
